module.exports = "/images/clock.svg?5b49230076f23f50c18dbabffa359002";